import { render, staticRenderFns } from "./groupE.vue?vue&type=template&id=981efad0&scoped=true"
import script from "./groupE.vue?vue&type=script&lang=js"
export * from "./groupE.vue?vue&type=script&lang=js"
import style0 from "./groupE.vue?vue&type=style&index=0&id=981efad0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981efad0",
  null
  
)

export default component.exports